var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.79 4.164-1.454-1.453a.7.7 0 0 0-.516-.211H7.977a1.515 1.515 0 0 0-1.055.445c-.281.282-.43.633-.445 1.055v6c.015.422.171.773.468 1.055.282.28.633.43 1.055.445h4.5a1.515 1.515 0 0 0 1.055-.445c.28-.282.43-.633.445-1.055V4.68a.7.7 0 0 0-.21-.516M12.874 10c-.016.234-.14.36-.375.375H7.977c-.235-.016-.36-.14-.375-.375V4q.0225-.3285.375-.375h3L11 4.75c0 .219.07.398.21.54.142.14.321.21.54.21h1.102V10h.023Zm-4.5 3c-.016.234-.14.36-.375.375H3.477c-.235-.016-.36-.14-.375-.375l.023-6c.016-.234.14-.36.375-.375h2.25V5.5H3.5a1.515 1.515 0 0 0-1.055.445c-.28.282-.43.633-.445 1.055v6c.016.422.164.773.445 1.055.282.28.633.43 1.055.445H8a1.515 1.515 0 0 0 1.055-.445c.28-.282.43-.633.445-1.055v-.75H8.398l-.023.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-icon.5b3c9732215f0aff3352652b899c27b7.svg";